import Service from './Service';

export interface UsageDataPoint {
  date: string;
  count: number;
}

export interface LockUsageDataPoint {
  lockId: number;
  count: number;
}

export interface UsageStats {
  data: UsageDataPoint[];
  total: number;
  subscription: {
    name: string;
    maxStations: number | null;
  } | null;
  billing?: {
    periodStart: string;
    periodEnd: string;
    quotaLimit: number | null;
    quotaUsed: number;
    overage: number;
  };
}

class SubscriptionService {
  private static URL_BASE = process.env.REACT_APP_URL_API;

  static getUsageStats(
    range: '1d' | '7d' | '30d' | '90d',
    from: string,
    stationToken?: string,
    to?: string,
  ): Promise<UsageStats> {
    const params = new URLSearchParams({ range, from });
    if (stationToken) params.set('station_token', stationToken);
    if (to) params.set('to', to);
    return Service.get(`${this.URL_BASE}/v1/subscriptions/usage?${params.toString()}`);
  }

  static getLockUsageStats(
    range: '1d' | '7d' | '30d' | '90d',
    from: string,
    stationId: number,
    to?: string,
  ): Promise<{ data: LockUsageDataPoint[] }> {
    const params = new URLSearchParams({ range, from, station_id: stationId.toString() });
    if (to) params.set('to', to);
    return Service.get(`${this.URL_BASE}/v1/subscriptions/lock-usage?${params.toString()}`);
  }
}

export default SubscriptionService;
